import { proxyHandler } from 'src/utils/redux';

const prefix = '@dailyBoost';

const constants = {
  setStateData: 'setStateData',
  setStateStatus: 'setStateStatus',
  setStateError: 'setStateError',
  applyBoostResult: 'applyBoostResult',
  closeSpin: 'closeSpin',
  closeMilestone: 'closeMilestone',
  showIntro: 'showIntro',
  reset: 'reset',
};

export const DAILY_BOOST_CONSTANTS = new Proxy(constants, proxyHandler(prefix));
